import {
  Button,
  chakra,
  Flex,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useToast,
} from "@chakra-ui/react";
import Issb from "api/issb/issb";
import { Controller, useForm } from "react-hook-form";
import { useQueryClient } from "react-query";
import { FormInput, FormSelect } from "components/Forms";
import SelectCountry from "./SelectCountry";
import { prettyPrintCodeName } from "utils/text-utils";
import { issbKeys } from "hooks/query";
import { SmallText } from "components/text/TextTypes";

// from json
import _SECTORS from "data/sectors.json";
import { showSuccessToast } from "../../../utils";
import { MultiSelect } from "../../../components/MultiSelect";
import React from "react";
import EsgFormLabel from "../../../components/Forms/EsgFormLabel";

// why??
const SECTORS = _SECTORS.filter((sector) => sector.subsectors);

/**
 * @param {Object} entity - see IssbEntity.java
 */
function EditEntityModal({ entity, isOpen, onClose, onDelete }) {
  const queryClient = useQueryClient();
  const toast = useToast();

  const postEntity = Issb.saveEntity;

  const doPostEntity = (data) => {
    // id (if 2nd save of a new entity)
    if (!data.id && entity.id) {
      data.id = entity.id;
    }
    // HACK: modify data to make sector and subsector an array
    if (data.sector) {
      // data.sectors = [data.sector];
      data.sectors = data.sector?.map((s) => s.value) || [];
    }
    if (data.subsector) {
      // data.subsectors = [data.subsector];
      data.subsectors = data.subsector?.map((s) => s.value) || [];
    }

    postEntity(data).then((data) => {
      console.log("postEntity data", data);
      // set entity.id if not set (i.e. save new entity)
      // if (!entity.id) {
      //   entity.id = data.id;
      // }
      queryClient.invalidateQueries(issbKeys.entity());
      showSuccessToast(toast, "Successfully saved entity");
      onClose();
    });
  };
  // HACK: modify local data to make sector and subsector a string
  // TODO support multiple select nicely in FormSelect
  if (entity?.sectors) {
    // entity.sector = entity.sectors[0];
    entity.sector = entity.sectors.map((s) => ({
      value: s,
      label: prettyPrintCodeName(s),
    }));
  }
  if (entity?.subsectors) {
    // entity.subsector = entity.subsectors[0];
    entity.subsector = entity.subsectors.map((s) => ({
      value: s,
      label: prettyPrintCodeName(s),
    }));
  }

  const { register, handleSubmit, formState, watch, control } = useForm({
    defaultValues: entity || { id: "new" },
  });
  console.log("formState", formState);
  const errors = formState?.errors;
  // use sector to filter subsectors
  const selectedSectors = watch("sector");
  let subsectors = [];

  if (selectedSectors) {
    console.log("selectedSector", selectedSectors);
    const selected = selectedSectors?.map((s) => s.value) || [];
    selected.forEach((s) => {
      subsectors.push(...SECTORS.find((sector) => sector.name === s)?.subsectors);
    });
  } else {
    SECTORS.filter((sector) => sector.subsectors).forEach((sector) => {
      subsectors.push(...sector.subsectors);
    });
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md">
      <ModalOverlay />
      <ModalContent bg="pureWhite">
        <chakra.form onSubmit={handleSubmit(doPostEntity)}>
          <ModalHeader>{entity ? "Update Entity" : "Create New Entity"}</ModalHeader>
          <ModalCloseButton />

          <ModalBody>
            <Flex direction="column" gap="2" marginBottom={10}>
              <FormInput
                label="Name"
                maxInlineSize={"var(--chakra-sizes-full)"}
                {...register("name", { required: true })}
                errors={errors}
              />

              <EsgFormLabel>Sector</EsgFormLabel>
              <Controller
                control={control}
                name="sector"
                render={({ field }) => (
                  <MultiSelect
                    options={SECTORS.map((sector) => ({
                      label: prettyPrintCodeName(sector.name),
                      value: sector.name,
                    }))}
                    placeholder="Select Sector"
                    value={field.value}
                    onChange={field.onChange}
                    isMulti
                  />
                )}
              />

              <EsgFormLabel>Subsector</EsgFormLabel>
              <Controller
                control={control}
                name="subsector"
                render={({ field }) => (
                  <MultiSelect
                    options={subsectors.map((subsector) => ({
                      label: prettyPrintCodeName(subsector.name),
                      value: subsector.name,
                    }))}
                    placeholder="Select Sub-Sector / Industry"
                    value={field.value}
                    onChange={field.onChange}
                    isMulti
                  />
                )}
              />

              <SmallText>
                The questions for a compliance round are filtered to fit the industry. This can greatly reduce the work
                in completing a compliance round.
              </SmallText>

              <HStack>
                <SelectCountry label="Country" {...register("place.countryIso")} />
                <FormInput label="Region" placeholder="e.g. Europe" {...register("place.region")} />
              </HStack>
            </Flex>
          </ModalBody>

          <ModalFooter justifyContent={entity ? "space-between" : "flex-end"}>
            {entity && onDelete && (
              <Button variant="ghost" colorScheme="red" onClick={onDelete}>
                Delete
              </Button>
            )}
            <HStack>
              <Button variant="ghost" onClick={onClose}>
                Cancel
              </Button>
              <Button colorScheme="customScheme" type="submit">
                Save
              </Button>
            </HStack>
          </ModalFooter>
        </chakra.form>
      </ModalContent>
    </Modal>
  );
}

export default EditEntityModal;
